import { Deserializable } from '../../protocols/deserializable';
import { Address } from './address';

export class MemberDeathRecordNotifyingParty implements Deserializable {
  public id!: number;
  public deathRecordId!: number;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public phoneNumberCountryCode!: string;
  public phoneNumber!: string;
  public address!: Address;

  public onDeserialize(): void {
    this.address = window.injector.Deserialize.instanceOf(Address, this.address);
  }
}
